import { Navigate } from "react-router-dom";
import { Activity } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { TorriMonitoring } from "@/components/monitoring/TorriMonitoring";

export default function TorriMonitoringPage() {
  const { user } = useAuth();
  if (!user) return null;
  if (!["admin", "head_of_partner", "back_office", "technical"].includes(user.role) && !["back_office", "technical"].includes(user.role_actual) && !(user.extra_pages || []).includes("monitoring")) return <Navigate to="/" replace />;
  return (
    <div className="space-y-6 p-4 sm:p-8" data-testid="torri-monitoring-page">
      <div>
        <h1 className="flex items-center gap-3 font-heading text-3xl font-extrabold tracking-tight sm:text-4xl"><Activity className="h-8 w-8 text-primary" />Torri Monitoring</h1>
        <p className="mt-1 text-sm text-muted-foreground">Stato in tempo reale degli impianti AURA dei clienti finali della rete.</p>
      </div>
      <TorriMonitoring base="/monitoring" accent="hsl(48 98% 50%)" showPartner canSync />
    </div>
  );
}
